import { i18n } from "@/i18n";

export default {
  path: "/studea-manager/:trainingCourseId/gradebook",
  name: "studeaManagerGradebookView",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("Gradebooks"),
    breadcrumb: true,
  },
  children: [
    {
      path: "edit",
      name: "studeaManagerGradebookEdit",
      component: () => import(/* webpackChunkName: "gradebook" */ "@/views/Gradebook/GradebookEditView.vue"),
      meta: {
        title: i18n.global.t("edit_gradebook"),
        breadcrumb: true,
      },
    },
  ],
};
